/*
  Everlles: two small behaviours on top of Easify Product Options.

  1. Default selection — Easify swatch groups (metal, gift box) are "required" but start with nothing
     selected, so Add to cart silently refuses until the customer clicks. When a small swatch group
     (up to 4 values) has no selection, the first "base" value (Silver / Plata / Standard / white box)
     is selected automatically. Easify only reacts to a real pointer sequence on the swatch image
     (pointerdown → mousedown → pointerup → mouseup → click), one group at a time, verified through
     the class Easify puts on the chosen label. Birthstone grids (12 values) are left alone.

  2. Children ↔ names — on the infinity name bracelets the price comes from the Shopify option
     "Select Number of Children", while Easify shows Child 1–6 name boxes regardless. Only the first N
     boxes stay visible (N = the selected number of children); the rest are hidden and emptied.

  Both re-run whenever Easify re-renders its options.
*/
(function () {
  var BASE = /silver|plata|plateado|standard|blanca|white|blanco|negro|black/i;
  var MAX_TRIES = 4;
  var tries = {};
  var busy = false;

  function isPicked(group) {
    var labels = group.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) if (labels[i].classList.contains('tpo_is_checked_swatches')) return true;
    var radios = group.querySelectorAll('input[type="radio"]');
    for (var j = 0; j < radios.length; j++) if (radios[j].checked) return true;
    return false;
  }

  function pointerClick(el) {
    var types = ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'];
    for (var i = 0; i < types.length; i++) {
      try { el.dispatchEvent(new MouseEvent(types[i], { bubbles: true, cancelable: true, view: window })); } catch (e) {}
    }
  }

  /* ---------- 1. default selection ---------- */
  function defaults() {
    if (busy) return;
    var groups = document.querySelectorAll('.tpo_option-type-image-swatches-wrapper');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var radios = group.querySelectorAll('input[type="radio"]');
      if (!radios.length || radios.length > 4) continue;
      if (isPicked(group)) continue;
      var key = radios[0].name || String(g);
      if ((tries[key] || 0) >= MAX_TRIES) continue;
      var pick = null;
      for (var j = 0; j < radios.length; j++) if (BASE.test(radios[j].value)) { pick = radios[j]; break; }
      if (!pick) pick = radios[0];
      var label = pick.closest('label') || pick.parentElement;
      var target = label.querySelector('img') || label;
      tries[key] = (tries[key] || 0) + 1;
      busy = true;
      pointerClick(target);
      setTimeout(function () { busy = false; schedule(); }, 700); // next group / retry on the re-rendered DOM
      return; // one group per pass
    }
  }

  /* ---------- 2. children count ↔ Child N name boxes ---------- */
  function childCount() {
    var inputs = document.querySelectorAll('variant-selects input[type="radio"], variant-selects select');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var val = el.tagName === 'SELECT' ? el.value : (el.checked ? el.value : null);
      if (!val) continue;
      var m = String(val).match(/^(\d+)\s*(child|children|hijo|hijos|niñ)/i);
      if (m) return parseInt(m[1], 10);
    }
    return 0;
  }

  function syncChildren() {
    var n = childCount();
    if (!n) return;
    for (var k = 1; k <= 8; k++) {
      var input = document.querySelector('input[name="properties[Child ' + k + ']"], input[name="properties[Hijo ' + k + ']"]');
      if (!input) continue;
      var box = input.closest('.tpo_option-label') || input.closest('.tpo_option-container') || input.parentElement;
      if (k > n) {
        if (input.value) {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        box.style.display = 'none';
        box.setAttribute('data-ev-hidden', '1');
      } else if (box.getAttribute('data-ev-hidden')) {
        box.style.display = '';
        box.removeAttribute('data-ev-hidden');
      }
    }
  }

  /* ---------- wiring ---------- */
  function run() { defaults(); syncChildren(); }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; run(); }, 150);
  }

  function start() {
    setTimeout(run, 600); // let Easify finish its first render
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects')) setTimeout(syncChildren, 50);
    });
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      setInterval(run, 1500);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
